/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableData from "../solicitudes/data/DataTableMaterial";
import SwitchR from "react-switch";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import {
  getSolicitudesT,
  getCatalogosT,
  getInformacionInicial,
  EliminarSolicitud,
} from "store/solicitudes/solicitudesActions";

import ModalContent from "../../components/ModalContent";
import VerticalTabs from "./tabs";
import FormBusqueda from "./forms/formBusqueda";
import Loading from "../../components/loading";
import { Divider } from "@mui/material";
import brandDark from "assets/images/LogoESF.png";
import { useNavigate } from "react-router-dom";
import SolicitudesBorradas from "../solicitudes/data/solicitudesborradas";
import _ from "lodash";
import { store } from "store/store";
import moment from "moment";

function Solicitudes() {
  //const {permisos} = useSelector((state) => state.roles);
  const usuario = store.getState().login.usuario;
  const { solicitudes, isloadingSolicitudes } = useSelector((state) => state.solicitud);
  const [openModalAdd, setopenModalAdd] = useState(false);
  const [checkavisoprivacidad, setcheckavisoprivacidad] = useState(false);
  const [checkacuerdo, setcheckacuerdo] = useState(false);
  const [openmodalConfirmacion, setopenmodalConfirmacion] = useState(false);
  const [rowSeleccionado, setrowSeleccionado] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Función reutilizable para cargar solicitudes (con o sin filtros)
  const loadSolicitudes = (filtros = {}) => {
    getSolicitudesT(dispatch, {
      ...filtros,
      esExpediente: true,
    });
  };
  const DeleteSolicitud = () => {
    dispatch(EliminarSolicitud(rowSeleccionado, true));
    setopenmodalConfirmacion(false);
    setrowSeleccionado(null);
    ejecutarConsultaSolicitudesBorradas();
  };

  // Carga inicial al montar el componente
  useEffect(() => {
    loadSolicitudes(); // Sin filtros
    getInformacionInicial(dispatch, true);
    getCatalogosT(dispatch);
  }, []);

  var solicitudesv = _.orderBy(solicitudes, ["fechaAplicacion"], ["desc"]);

  const columnsSolicitudes = useMemo(
    () => [
      ...(usuario.username == "soporte"
        ? [
            {
              accessorKey: "idSolicitud",
              header: "ID_BD",
              size: 30,
            },
          ]
        : []),
      {
        accessorKey: "idSolicitudConsecutivo",
        header: "",
        size: 30,
        Cell: ({ row }) => {
          return solicitudesv.length - row.index;
        },
      },
      {
        accessorKey: "precandidato", //access nested data with dot notation
        header: "Precandidato",
        size: 100,
      },
      {
        accessorKey: "fechaNacimiento",
        header: "Fecha de nacimiento",
        size: 100,
        Cell: ({ row }) => {
          return moment(row.original.fechaNacimiento).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "fechaAplicacion", //normal accessorKey
        header: "Fecha de aplicacion",
        Cell: ({ row }) => {
          return moment(row.original.fechaAplicacion).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "parentescoCandidato",
        header: "Parentesco",
        size: 150,
      },
      {
        accessorKey: "correoContacto",
        header: "Correo",
        size: 150,
      },
    ],
    [solicitudesv.length]
  );

  const refBorradas = useRef();

  const ejecutarConsultaSolicitudesBorradas = () => {
    if (refBorradas.current) {
      refBorradas.current.ejecutarConsulta();
    }
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const verexpediente = _.filter(usuarioPermisos, (p) => p.idPermiso == 94);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Administrar expedientes
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right"></MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox textAlign="center" mt={3} ml={2} mr={2}>
                <FormBusqueda onSearch={loadSolicitudes} />
                <Divider />
                <MDBox textAlign="center">
                  <MDTypography component="p" variant="button" color="white">
                    <MDTypography
                      component="span"
                      variant="button"
                      fontWeight="bold"
                      color="success"
                    >
                      {solicitudesv.length}
                    </MDTypography>
                    &nbsp;{"Total de expedientes"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {isloadingSolicitudes ? (
                  <Loading title={"Procesando por favor espere"} />
                ) : (
                  <TableData
                    columns={columnsSolicitudes}
                    data={solicitudesv}
                    showModal={() => {
                      setopenModalAdd(true);
                    }}
                    VerSolicitud={(row, esSolicitud, ids) => {
                      navigate("/detallesE", {
                        state: {
                          id: row.idSolicitud,
                          vista: "expediente",
                          idMostrar: ids,
                        },
                      });
                    }}
                    esSolicitud={false}
                    EliminarSolicitud={(row) => {
                      setrowSeleccionado(row);
                      setopenmodalConfirmacion(true);
                    }}
                  />
                )}
                <Divider />
                {verexpediente.length == 0 ? null : (
                  <SolicitudesBorradas
                    ref={refBorradas}
                    columns={columnsSolicitudes}
                    esExpediente={true}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ModalContent
        title={""}
        maxWidth="lg"
        fullWidth={true}
        open={openModalAdd}
        fullScreen={false}
        handleClose={() => {
          setopenModalAdd(false);
        }}
        handleAcept={() => {
          setopenModalAdd(false);
        }}
        textAccept=""
        alert={alert}
        onCloseAlert={() => {}}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={4}>
            <MDBox textAlign="center">
              <img src={brandDark} style={{ height: "3rem" }}></img>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={8} lg={8}>
            <MDBox textAlign="center">
              <MDTypography variant="h6" color="text">
                Formato para candidatos a implante coclear
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="center">
              <Button
                variant="contained"
                onClick={() => {}}
                sx={{ mt: 1, mr: 1 }}
                size="small"
                color="primary"
              >
                Ver aviso de privacidad
              </Button>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox display="flex" alignItems="center" paddingTop="0.8rem">
              <MDBox mt={0.5}>
                <SwitchR
                  onChange={() => {
                    setcheckavisoprivacidad(!checkavisoprivacidad);
                  }}
                  checked={checkavisoprivacidad}
                  height={20}
                  width={50}
                  handleDiameter={18}
                  onColor="#605CA9"
                />
              </MDBox>
              <MDBox ml={0.5}>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  He leído y acepto el aviso de privacidad
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox display="flex" alignItems="center">
              <MDBox mt={0.5}>
                <SwitchR
                  onChange={() => {
                    setcheckacuerdo(!checkacuerdo);
                  }}
                  checked={checkacuerdo}
                  height={20}
                  width={50}
                  handleDiameter={18}
                  onColor="#605CA9"
                />
              </MDBox>
              <MDBox ml={0.5}>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  Estoy de acuerdo que la recepción de esta solicitud no constituye una obligación
                  de ninguna especie entre el solicitante y Fundación Grupo México A.C. , al
                  enviarla estamos aceptando que se realice la evaluación y el resultado de esta.
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
        <VerticalTabs />
      </ModalContent>
      <ModalContent
        title={"Eliminar Expediente"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalConfirmacion}
        fullScreen={false}
        handleClose={() => {
          setrowSeleccionado(null);
          setopenmodalConfirmacion(false);
        }}
        handleAcept={() => {
          DeleteSolicitud();
        }}
        textAccept="Aceptar"
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Realmente desea eliminar el expediente?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <Footer />
    </DashboardLayout>
  );
}

export default Solicitudes;
